import {styled} from '../../../utils';
import {Sider} from '../../Layout';

export default styled(Sider)(({theme: {globalSider: {width, backgroundColor, zIndex}}}) => ({
  flexBasis: width,
  width,
  height: '100vh',
  transition: 'width .2s',
  position: 'fixed',
  bottom: 0,
  left: 0,
  backgroundColor,
  zIndex
}));



// WEBPACK FOOTER //
// ./src/components/GlobalLayout/Sider/Sider.tsx